import React, {useEffect, useRef, useState} from 'react';
import {Button} from "react-bootstrap";
import {connect, DispatchProp} from "react-redux";
import QRCode from "qrcode";
import {RootState} from "../../../../reducers";
import ErrorFormAlertView from "../../Common/ErrorFormAlertView";
import {getLocation, selectLocale} from "../../../services/Session/reducer";
import {getStoreConfig, getStoreConfigLoyalty} from "../../../services/Store/reducer";
import {useTranslation, withTranslation} from "react-i18next";
import UserUtils from "../../../services/User/UserUtils";
import {useCart} from "../../../services/Cart/cartService";
import handleException from "../../../services/Api/handleException";
import {VoucherApi} from "../../../services/Api/types";
import {ReactComponent as GiftIco} from "../../../../images/icons/gift.svg";
import appConfig from "../../../services/AppConfig";
import PopupModal from "../../Modal/PopupModal";
import IframeWidget from "../../../utils/IframeWidget";
import StoreUtils from "../../../services/Store/StoreUtils";

interface OwnProps {
    voucher: any,
    show: boolean,
    onHide: () => void;
    handlePromotionChange: (promotionId?: string) => Promise<void>;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function VoucherModal(props: Props) {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState<any[]>([]);
    const canvasRef = useRef(null);
    const voucher = props.voucher;
    const product = voucher.product;
    let cartService = useCart();
    let {t} = useTranslation();
    const isLocationSelected = !!props.config;

    useEffect(() => {
        if (canvasRef.current) {
            QRCode.toCanvas(canvasRef.current, voucher.code, {width: 172}, (error: any) => {
                if (error) console.error(error);
            });
        }
    }, []);

    const isVoucherAvailableForLocation = (voucher: VoucherApi) => {
        // return voucher.promotion_id || voucher.credit;
        return true;
    }
    const voucherAvailableForLocation = isVoucherAvailableForLocation(voucher);

    const addVoucher = async (voucher: any) => {
        setLoading(true);
        if (!isLocationSelected) {
            setLoading(false);
            setErrors([{message: t("constraints.internal.choose_restaurant")}]);
            return;
        }
        try {
            await cartService.addOrderVoucher(voucher.code);
            await props.handlePromotionChange(voucher.promotion_id);
            setLoading(false);
            IframeWidget.onHide(props.onHide)
        } catch (e) {
            setErrors(handleException(e));
            setLoading(false);
        }
    }

    return <PopupModal
        title={product.name}
        description={product.description}
        show={props.show}
        onHide={props.onHide}
        headerIcon={<GiftIco/>}
        headerIconClassName="text-success"
        primaryButton={StoreUtils.isOrderingReadonly(props.config) ? undefined :
            <Button
                className={`btn btn-spinner btn-primary w-100 ${loading ? " loading disabled" : ""}${voucherAvailableForLocation ? "" : " disabled"}`}
                onClick={() => addVoucher(voucher)}>
                <span className="left spinner-border spinner-border-sm"/>
                {t("modules.user.action.add_to_cart.title")}
            </Button>
        }
        bodyContent={
            <div className="voucher-full voucher-modal-body" aria-live="polite">
                {(isLocationSelected && !voucherAvailableForLocation) && (
                    <ErrorFormAlertView errors={[t("constraints.internal.voucher_not_available_for_location")]}/>
                )}
                <div className={`${appConfig.isDarkMode() ? "mb-0" : "mb-0"}`}>
                    <div className="my-2">
                        <ErrorFormAlertView errors={errors}/>
                    </div>
                </div>
                {UserUtils.isLoyaltyQrcodeEnabled(props.config_loyalty) && voucher.code && (
                    <>
                        <div className={"voucher-full-qrcode"}>
                            <div className={"qrcode"}>
                                <canvas ref={canvasRef}/>
                            </div>
                            <p className={"info"}>
                                {t("modules.user.field.scan_code.title")}
                            </p>
                        </div>
                        {
                            !StoreUtils.isOrderingReadonly(props.config) && (
                                <div className="horizontal-divider">
                                <span>{t("common.word.or")}
                                </span>
                                </div>
                            )
                        }
                    </>
                )}
            </div>
        }
    />
}

const mapStateToProps = (state: RootState) => ({
    location: getLocation(state.session),
    locale: selectLocale(state.session),
    config_loyalty: getStoreConfigLoyalty(state.config),
    config: getStoreConfig(state.config)
})
const connector = connect(mapStateToProps);
export default withTranslation()(connector(VoucherModal));
